import styled from '../../../styles/theme';
import { RangeStyled } from '../RangeStyled';
import { rem } from 'polished';

export const RangeStyledDS = styled(RangeStyled)`
    .rc-slider-rail {
        background-color: ${props => props.theme.colors.grey1};
        height: ${rem('3px')};
        position: absolute;
        top: 0px;
    }

    .rc-slider {
        position: relative;
        height: 1.0rem;
        width: 90%;
        padding: 5px 0;
    }

    .rc-slider-track {
        background-color: ${props => props.theme.colors.grey4};
        border-radius: 0px;
        position: absolute;
        width: 100%;
        height: 0.1rem;
        top: 0px;
    }

    .rc-slider-track {
        position: absolute;
        border-radius: 0px;
        left: 0;
        height: 0.1rem;
        background-color: #8E8F91;
    }

    .rc-slider-handle {
        cursor: grab;
        position: absolute;
        position: absolute;
        left: ${rem('9.56px')};
        right: ${rem('-9.15px')};
        top: 0px;
        bottom: ${rem('0.41px')};
        border-radius: 0px;
        border 0px;
        background: #1A1B1B !important;
        transform: translateX(-50%) rotate(45deg) !important;
        margin-top: ${rem('-6px')};
        background-color: ${props => props.theme.colors.secondary};
    }
    .rc-slider-handle-dragging {
        box-shadow: 0 0 2px 2px ${props => props.theme.colors.secondaryHover};
        background: ${props => props.theme.colors.secondaryHover};
    }
    .rc-slider-handle:hover {
        box-shadow: 0 0 1px 1px ${props => props.theme.colors.secondaryHover};
    }
`;
